import { Box } from '@mui/material'
import { type EventDTO, HorizontalCard, VerticalCard } from '~entities/index'
import { container1Sx, container2Sx, items1Sx, items2Sx, items3Sx, items4Sx } from './styles'

const sxConfig = {
	1: items1Sx,
	2: items2Sx,
	3: items3Sx,
	4: items4Sx
}

export const ThreeCardsGroup = ({
	type,
	events
}: {
	type: 1 | 2 | 3 | 4
	events: EventDTO[]
}) => {
	const isSmall = type === 2 || type === 4
	const isHorizontalFirst = type === 2 || type === 3

	const columns = isHorizontalFirst
		? [
			{ eventIndex: 0, Card: HorizontalCard, isSmall: !isSmall },
			{ eventIndex: 1, Card: VerticalCard, isSmall: isSmall },
			{ eventIndex: 2, Card: VerticalCard, isSmall: isSmall }
		]
		: [
			{ eventIndex: 0, Card: VerticalCard, isSmall: isSmall },
			{ eventIndex: 1, Card: VerticalCard, isSmall: isSmall },
			{ eventIndex: 2, Card: HorizontalCard, isSmall: !isSmall }
		]

	return (
		<Box
			minWidth={isSmall ? '672px' : '864px'}
			sx={isSmall ? container2Sx : container1Sx}
		>
			{columns.map(({ eventIndex, Card, isSmall }) => (
				<Card
					key={eventIndex}
					sx={sxConfig[type][eventIndex]}
					info={events[eventIndex]}
					isSmall={isSmall}
				/>
			))}
		</Box>
	)
}
